// extracted by mini-css-extract-plugin
export default {"overlay":"Promotion_overlay__rdIAl","bPopup":"Promotion_bPopup__iKHk7","fadeIn":"Promotion_fadeIn__o60TO"};